import React from 'react'

const SideImage = props => (
    <div className="side-image">
        <img
            src={props.backgroundImage}
            className="side-image__img side-image__img--back"
        />
        <img
            src={props.foregroundImage}
            className={'side-image__img side-image__img--front'}
            style={{ top: props.foregroundTop }}
        />
    </div>
)

SideImage.defaultProps = {
    backgroundImage: '',
    foregroundImage: '',
    foregroundTop: '12%'
}

export default SideImage



// WEBPACK FOOTER //
// ./src/scripts/components/SideImage.jsx